import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const RegisteredRoute = props => {

    // Read Redux state
	const regUserDetails = useSelector((state) => state.registeredUserDetails);
    const { loginSuccess, userData } = regUserDetails;

    // Consider the user logged in if loginSuccess is true OR persisted userData includes a rewardsId
    const isLoggedIn = Boolean(loginSuccess) || Boolean(userData && userData.rewardsId);

  // If logged in, display the backoffice screen
    if(isLoggedIn) {
        return <Route {...props} />;
    }
    // Otherwise if not logged in, redirect to login page
    else {
        return <Redirect to="/registeredlogin" />;
    }
}

export default RegisteredRoute